"use strict";

var _slicedToArray = require("/Volumes/Media/bschlenk/Workspace/set/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var xstate_1 = require("xstate");

var interpreter_1 = require("xstate/lib/interpreter");

function useMachine(config, options, initialContext) {
  var machine = react_1.useMemo(function () {
    return xstate_1.Machine(config, options, initialContext);
  }, []);

  var _react_1$useState = react_1.useState(machine.initialState),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      state = _react_1$useState2[0],
      setState = _react_1$useState2[1];

  var _react_1$useState3 = react_1.useState(machine.context),
      _react_1$useState4 = _slicedToArray(_react_1$useState3, 2),
      context = _react_1$useState4[0],
      setContext = _react_1$useState4[1]; // Setup the service only once.


  var service = react_1.useMemo(function () {
    var service = interpreter_1.interpret(machine);
    service.onTransition(function (state) {
      return setState(state);
    });
    service.onChange(setContext); // call init after the above callbacks are set so any immediate actions
    // are reflected in react's state

    service.init();
    return service;
  }, []); // Stop the service when unmounting.

  react_1.useEffect(function () {
    return function () {
      return service.stop();
    };
  }, []);
  return {
    state: state,
    send: service.send,
    context: context,
    service: service
  };
}

exports.useMachine = useMachine;